<app-reactive-dialog-content [data]="dialogInputData">
  <div class="flex-container">
    <div>
      <app-spacer></app-spacer>
      <div class="option-container">
        Hier können Sie die {{ genehmigungFile.name }} unterschreiben lassen:
        <div class="button-container center">
          <button mat-raised-button color="accent" (click)="onUnterschreibenClick()">
            Unterschreiben
          </button>
        </div>
      </div>
      <app-spacer></app-spacer>
      <div class="option-container">
        Oder herunterladen/händisch hochladen:
        <div class="button-container center">
          <button mat-raised-button color="accent" class="main button-right-margin"
                  (click)="onHerunterladenClick()">Herunterladen
          </button>
          <input id="file-upload" type="file"
                 class="display-none" accept="application/pdf"
                 (change)="onFilesAdded()"
                 #fileChooser>
          <button mat-raised-button color="accent"
                  (click)="clickUpload()">Hochladen
          </button>
        </div>
      </div>
    </div>
  </div>
</app-reactive-dialog-content>
